<template>
<div class="d-flex flex-row flex-column-fluid page" :style="progressLoader ? 'pointer-events: none;opacity:0.7' : 'pointer-events: auto'">
    <div class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
         <!-- <div class="pb-10"></div> -->
         <!-- <notifications group="notification" /> -->
         <topbar></topbar>
         <div class="container-fluid">
            <notifications    width="400" group="notify" position="top right"/>
            <loader v-if="progressLoader"></loader>
            <router-view :stripe-status="stripeStatus"/>   
         </div>
         <ShopFooter></ShopFooter> 
    </div>
</div>
</template>
<script>
import quickPanel from './shop/shop-quick-panel.vue';
import sidebar from './shop/shop-sidebar.vue';
import topbar from './shop/shop-topbar.vue';
import ShopFooter from './shop/shop-footer.vue';
import PlansAPIService from '@/js/api/manage-plans/plans';
import Loader from "./Loader.vue";
export default {
	name: 'ShopLayout',
	components: {
		sidebar,
		topbar,
		ShopFooter,
		quickPanel,
        Loader
   	},
    data(){
        return {
            stripeStatus: ''
        }
    },
     computed:{
        progressLoader(){
			  return this.$store.state.loader
		}
    },
    mounted(){
        PlansAPIService.getPlansAndSubscription(localStorage.getItem('access-token')).then((response) => {
            this.stripeStatus = response.data?.subscription?.stripe_status || '';
        });
        this.$i18n.locale=this.$store.getters.brand['default_brand_language']
        if (this.$store.getters.brand && this.$store.getters.brand.brand_name) {
            document.title = this.$store.getters.brand.brand_name;
        }
    }
};
</script>
<style scoped>
  @media (min-width: 992px) {
     body.header-fixed[data-header-scroll="on"] {
         padding-top: 100px;
    }
     .main {
         border-top-left-radius: 0;
    }
     .aside-enabled .main {
         border-bottom-left-radius: 0;
    }
     .container {
         padding: 0 25px;
    }
     .container-fluid, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
         padding: 0 100px;
    }
}
 @media (max-width: 991.98px) {
     .container, .container-fluid, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
         max-width: none;
         padding: 0 15px;
    }
}


</style>